export default __webpack_public_path__ + "static/media/03LeDesert60s.3a1256db.mp3";